import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import useAuthStore from "../../store/authStore";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuthStore();
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    // Wait for Zustand persist to hydrate from localStorage
    const unsub = useAuthStore.persist?.onFinishHydration(() => setHydrated(true));
    // Also set a timeout fallback in case onFinishHydration doesn't fire
    const timer = setTimeout(() => setHydrated(true), 100);
    // If already hydrated (no persist or instant hydration)
    setHydrated(true);
    return () => {
      unsub?.();
      clearTimeout(timer);
    };
  }, []);

  if (!hydrated) return null; // Wait — don't redirect yet
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

export default ProtectedRoute;
